import type {PayloadAction} from '@reduxjs/toolkit'

import {createSlice} from '@reduxjs/toolkit'

import type {Event} from '../../types/openmeter-api'

export interface OpenmeterState {
  isLoading: boolean,
  error: string,
  currentPath: string,
  events: Event[],
  eventsDailyCategories: string[];
  eventsDailyData: number[];
  eventsWeeklyCategories: string[];
  eventsWeeklyData: number[];
  eventsMonthlyCategories: string[];
  eventsMonthlyData: number[];
  eventsYearlyCategories: string[];
  eventsYearlyData: number[];
}



const initialState: OpenmeterState = {
  isLoading: false,
  error: '',
  currentPath: '/',
  events: [],
  eventsDailyCategories: [],
  eventsDailyData: [],
  eventsWeeklyCategories: [],
  eventsWeeklyData: [],
  eventsMonthlyCategories: [],
  eventsMonthlyData: [],
  eventsYearlyCategories: [],
  eventsYearlyData: [],
}

export const openmeterSlice = createSlice({
  name: 'openmeter',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true
    },
    stopLoading: (state) => {
      state.isLoading = false
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    setEvents: (state, action: PayloadAction<Event[]>) => {
      state.isLoading = false
      state.events = action.payload
    },
    setEventsDailyCategories: (state, action: PayloadAction<string[]>) => {
      state.isLoading = false
      state.eventsDailyCategories = action.payload
    },
    setEventsDailyData: (state, action: PayloadAction<number[]>) => {
      state.isLoading = false
      state.eventsDailyData = action.payload
    },
    setEventsWeeklyCategories: (state, action: PayloadAction<string[]>) => {
      state.isLoading = false
      state.eventsWeeklyCategories = action.payload
    },
    setEventsWeeklyData: (state, action: PayloadAction<number[]>) => {
      state.isLoading = false
      state.eventsWeeklyData = action.payload
    },
    setEventsMonthlyCategories: (state, action: PayloadAction<string[]>) => {
      state.isLoading = false
      state.eventsMonthlyCategories = action.payload
    },
    setEventsMonthlyData: (state, action: PayloadAction<number[]>) => {
      state.isLoading = false
      state.eventsMonthlyData = action.payload
    },
    setEventsYearlyCategories: (state, action: PayloadAction<string[]>) => {
      state.isLoading = false
      state.eventsYearlyCategories = action.payload
    },
    setEventsYearlyData: (state, action: PayloadAction<number[]>) => {
      state.isLoading = false
      state.eventsYearlyData = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  startLoading,
  stopLoading,
  hasError,
  setEvents,
  setEventsDailyCategories,
  setEventsDailyData,
  setEventsWeeklyCategories,
  setEventsWeeklyData,
  setEventsMonthlyCategories,
  setEventsMonthlyData,
  setEventsYearlyCategories,
  setEventsYearlyData
} = openmeterSlice.actions

export default openmeterSlice.reducer
